import { ChatApplyContainerProps, ChatApplyControllerProps } from './chatApplyProps';
import { ChatApplyController, ChatApplyLoader } from './chatApplyInterface';
import { ReportingShellContainerBaseConfig } from '../../../../base';
import { assert } from '@varos/util-typescript';

export function createChatApplyContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatApplyLoader,
    controller: ChatApplyController
): React.FC<ChatApplyContainerProps> {
    const {
        repository: { research: repository },
        context: { useContext },
        pubsub: { router: pubsub },
    } = config;

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, { item });
        const props = controller.useProps(context, data, {
            onOpen() {
                console.log('opening document');
                pubsub.dispatch({
                    kind: 'open',
                    data: {
                        content: {
                            id: item.tool.args.suggestion.document,
                        },
                    },
                });
            },
            async onReject(operation, index) {
                assert(data.suggestion, 'suggestion is required');
                console.log('rejecting', operation, index);
                pubsub.dispatch({
                    kind: 'reject',
                    data: {
                        index,
                        operation,
                    },
                });
            },
            async onAccept(operation, index) {
                assert(data.suggestion, 'suggestion is required');
                pubsub.dispatch({
                    kind: 'approve',
                    data: {
                        index,
                        operation,
                    },
                });
            },
        });
        return <View {...props} />;
    };
}
